import { FormValues, Role } from '../FeedbackForm/types';


export const initialFormValues: FormValues = {
    role: Role.INVESTOR,
    rate: 0,
};
